import { FormGroupWithInlineButtons, FormGroupWithInlineButtonsProps } from "./FormGroupWithInlineButtons";
import { Translation } from "../TranslationWrapper/TranslationWrapper";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import React, { createContext } from "react";

export const FormNameContext = createContext<string>("");

export function FormGroupWithInlineButtonsTC({
  children,
  formField,
  tKey,
  tDefault,
}: FormGroupWithInlineButtonsProps & Translation) {
  return (
    <FormNameContext.Provider value={formField.props.name}>
      <FormFieldTwoColumns noclone tDefault={tDefault} tKey={tKey}>
        <FormGroupWithInlineButtons formField={formField}>{children}</FormGroupWithInlineButtons>
      </FormFieldTwoColumns>
    </FormNameContext.Provider>
  );
}
